/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ClientEmailOptOutUpdateMutationVariables = Types.Exact<{
  input: Types.ClientNotificationEmailOptOutUpdateInput;
}>;
export type ClientEmailOptOutUpdateMutation = {
  __typename?: "Mutation";
  clientNotificationEmailOptOutUpdate?: {
    __typename?: "ClientNotificationEmailOptOutUpdatePayload";
    result: {
      __typename?: "ClientNotificationEmailOptOutUpdateError";
      code: Types.ClientNotificationEmailOptOutUpdateErrorCode;
    } | {
      __typename?: "ClientNotificationEmailOptOutUpdateSuccess";
      emailOptOut: boolean;
    };
  } | null;
};
export const ClientEmailOptOutUpdateDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "ClientEmailOptOutUpdate"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ClientNotificationEmailOptOutUpdateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "clientNotificationEmailOptOutUpdate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "ClientNotificationEmailOptOutUpdateSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "emailOptOut"
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "ClientNotificationEmailOptOutUpdateError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "code"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type ClientEmailOptOutUpdateMutationFn = Apollo.MutationFunction<ClientEmailOptOutUpdateMutation, ClientEmailOptOutUpdateMutationVariables>;

/**
 * __useClientEmailOptOutUpdateMutation__
 *
 * To run a mutation, you first call `useClientEmailOptOutUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientEmailOptOutUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientEmailOptOutUpdateMutation, { data, loading, error }] = useClientEmailOptOutUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientEmailOptOutUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ClientEmailOptOutUpdateMutation, ClientEmailOptOutUpdateMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<ClientEmailOptOutUpdateMutation, ClientEmailOptOutUpdateMutationVariables>(ClientEmailOptOutUpdateDocument, options);
}
export type ClientEmailOptOutUpdateMutationHookResult = ReturnType<typeof useClientEmailOptOutUpdateMutation>;
export type ClientEmailOptOutUpdateMutationResult = Apollo.MutationResult<ClientEmailOptOutUpdateMutation>;
export type ClientEmailOptOutUpdateMutationOptions = Apollo.BaseMutationOptions<ClientEmailOptOutUpdateMutation, ClientEmailOptOutUpdateMutationVariables>;